<script lang="ts" setup>
import IconSprite from '@/uiKit/IconSprite.vue'
</script>

<template>
  <div class="text-icon-subtlest">
    <IconSprite icon="chevron-right" />
  </div>
</template>
